export const FOCUS_FORM_INPUT_EVENT_NAME = 'focusFormInput' as const;

export interface FocusFormInputEventData {
  name: string;
  preventScroll?: boolean;
}

export const emitFocusFormInput = (name: string, preventScroll?: boolean) => {
  document.dispatchEvent(
    new CustomEvent(FOCUS_FORM_INPUT_EVENT_NAME, {
      detail: { name, preventScroll },
    }),
  );
};

export const listenFocusFormInput = (
  listener: (
    this: Document,
    event: DocumentEventMap[typeof FOCUS_FORM_INPUT_EVENT_NAME],
  ) => any,
) => {
  document.addEventListener(FOCUS_FORM_INPUT_EVENT_NAME, listener);
  return () =>
    document.removeEventListener(FOCUS_FORM_INPUT_EVENT_NAME, listener);
};
